export const resolveMinRead = (value: number | null | undefined, suffix?: string): string | undefined => {
    if (!value) {
        return undefined;
    }

    return `${value}${suffix ? ` ${suffix}` : ''}`;
};
